import { User } from '@/types/tower/v2/User';

export interface TableauDashboard {
    id: number;
    name: string;
    tableauType: string;
    dashboardUrl: string;
    tableauId: number;
    viewName: string;
    workbookName: string;
    accountId: number;
    accountDerivedName?: string;
    createdDate: string;
    updatedAt: string | null;
    viewPath?: string;
    user: User;
		tableauTypeId: number;
    analyticsTypeId: number;
    published: boolean;
    pinned?: boolean;
    reportingType?: string;
    tableauTypeName?: string;
    linkStatus?: TableauLinkStatus;
    linkCheckedAt?: string | null;
}

export type TableauLinkStatus =
    | 'UNCHECKED'
    | 'OK'
    | 'WORKBOOK_NOT_FOUND'
    | 'VIEW_NOT_FOUND'
    | 'INVALID_URL'
    | 'WRONG_HOST';

export function isBrokenTableauLink(status?: TableauLinkStatus | null): boolean {
    return !!status && status !== 'OK' && status !== 'UNCHECKED';
}

export interface CreateTableauRequest {
    accountId?: number | null;
    name: string;
    dashboardUrl: string;
    tableauTypeId: number;
}

export interface UpdateTableauRequest {
    accountId?: number | null;
    name: string;
    dashboardUrl: string;
    tableauTypeId: number;
}

export interface TableauType {
	id: number;
	name: string;
	analyticsTypeId?: number;
	analyticsType?: string;
}
